// components/ProtectedRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router';
import { jwtDecode } from 'jwt-decode';

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateToken = () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        console.log(decodedToken);
        const isValid = decodedToken.exp * 1000 > Date.now();
        setIsAuthenticated(isValid);
        console.log(isValid);
        if (isValid) {
          setUserRole(decodedToken.role); // Assuming role is included in the JWT
        } else {
          console.log("----------");
          localStorage.removeItem('token');
        }
      } catch (error) {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
      }
      setIsLoading(false);
    };

    validateToken();
  }, []);

  if (isLoading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};
